import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

const SocialBar = ({ children, content = [], ...props }) => {
  return (
    <div className={cn("social-bar", props.className)}>
      <ul>
        {content.map((item, i) => <li key={i} className={item.name}><a target="_blank" rel="noopener noreferrer" href={item.url}><i className={item["fontawesome-icon"]}></i></a></li>)}
      </ul>
    </div>
  );
};

SocialBar.propTypes = {
  content: PropTypes.array.isRequired,
  className: PropTypes.string
};

export default SocialBar;



// WEBPACK FOOTER //
// ./src/components/resume/SocialBar.js